import {
  api
} from "../api";
import {
  getToken
} from "../auth";

export const getUsersPermissions = (eventId, groupId) => {
  return api({
      url: `/event-group-permission/users-with-permission/${eventId}/${groupId}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
    .then((response) => response)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return error.request;
      } else {
        return error.message;
      }
    });
};

export const getUsersWithoutPermissions = (eventId, groupId) => {
  return api({
      url: `/event-group-permission/users-without-permission/${eventId}/${groupId}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
    .then((response) => response)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return error.request;
      } else {
        return error.message;
      }
    });
};

export const postPeoplePermissionEvent = (eventId, groupId, userIds) => {
  return api({
      url: `/event-group-permission/${eventId}/${groupId}`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      data: {
        userIds
      },
    })
    .then((response) => response)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return error.request;
      } else {
        return error.message;
      }
    });
};

export const deletePeoplePermissionEvent = (eventId, groupId, userIds) => {
  return api({
      url: `/event-group-permission/${eventId}/${groupId}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      data: {
        userIds
      },
    })
    .then((response) => response)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return error.request;
      } else {
        return error.message;
      }
    });
};

export const patchPermissionsUserEvent = (eventId, groupId, userIdEdit, data) => {
  return api({
      url: `/event-group-permission/${eventId}/${groupId}/${userIdEdit}`,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      data: data,
    })
    .then((response) => response)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return error.request;
      } else {
        return error.message;
      }
    });
};